import React from 'react'
import PropTypes from 'prop-types'

import { Card, CardContent, CardHeading } from '@components/layout/Card'
import { CodeBlock } from '@components/CodeBlock'

const WealthManagersReferralCard = ({ wealthManagerUniqueSignupUrl }) => (
  <Card id="unique-signup-link">
    <CardHeading>
      <h5>Unique signup link</h5>
    </CardHeading>
    <CardContent>
      <p>Anyone who uses this link to sign up will automatically end up on your prospect list.</p>
      <p>You can use this link anywhere, including social media, WhatsApp messages, or even email campaigns.</p>
      <p>Simply copy the link, share it, and watch the magic happen.</p>
      <CodeBlock text={wealthManagerUniqueSignupUrl}/>
    </CardContent>
  </Card>
)

WealthManagersReferralCard.propTypes = {
  wealthManagerUniqueSignupUrl: PropTypes.string.isRequired
}

export default WealthManagersReferralCard
